module.exports = __webpack_public_path__ + "img/panelView_strongBg_2_1.cfd77928.png";